
import BuyCrypto from "../../../assets/duotone/BuyCrypto.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function BuyCryptoIcon({ className, dataTestid = "BuyCryptoIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <BuyCrypto data-testid={dataTestid} className={classes} {...rest} />
  );
}
